/* istanbul ignore file */
export const PRODUCT_IMAGES_TABPANEL_ID_PREFIX = 'product-images-tabpanel-';
export const PRODUCT_IMAGES_TABPANEL_CONTAINER_ID = 'product-images-tabpanel-container';
export const IMAGES_ID_PREFIX = 'fullscreen-';

export const ZOOM_PAN_WRAPPER_CLASS = 'zoom-pan-wrapper';
export const ZOOM_PAN_CONTENT_CLASS = 'zoom-pan-content';
export const PRODUCT_IMAGE_TABPANEL_CLASS = 'product-image__tabpanel';
